/**
 * This file is auto generated do not manually adjust.
 * To create run 'npm run animation:generate-constants'
 */
/* eslint @typescript-eslint/naming-convention : 0 */
export const Animations = {
    ERROR: 'error',
    PAYMENTREQUESTCOMPLETED: 'paymentrequestcompleted',
    PIGGYBANKACHIEVED: 'piggybankachieved',
    PIGGYBANKCREATEDSUCCESSFUL: 'piggybankcreatedsuccessful',
    SCHEDULEDTRANSFERSUCCESSFUL: 'scheduledtransfersuccessful',
    SIGNUPSUCCESSFUL: 'signupsuccessful',
    TRANSFERFAILED: 'transferfailed',
    TRANSFERPIGGYBANKSUCCESSFUL: 'transferpiggybanksuccessful',
    TRANSFERPROGRESS: 'transferprogress',
    TRANSFERSUCCESSFUL: 'transfersuccessful'
};

export enum AvailableAnimations {
    ERROR = 'error',
    PAYMENTREQUESTCOMPLETED = 'paymentrequestcompleted',
    PIGGYBANKACHIEVED = 'piggybankachieved',
    PIGGYBANKCREATEDSUCCESSFUL = 'piggybankcreatedsuccessful',
    SCHEDULEDTRANSFERSUCCESSFUL = 'scheduledtransfersuccessful',
    SIGNUPSUCCESSFUL = 'signupsuccessful',
    TRANSFERFAILED = 'transferfailed',
    TRANSFERPIGGYBANKSUCCESSFUL = 'transferpiggybanksuccessful',
    TRANSFERPROGRESS = 'transferprogress',
    TRANSFERSUCCESSFUL = 'transfersuccessful'
}
